// @flow
import { Box, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { GatsbyImage } from 'gatsby-plugin-image';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import chunk from 'lodash.chunk';
import * as React from 'react';

type Props = {
  items: Array<any>,
  title: string,
  galleryIndex: number,
};

const useStyles = makeStyles((theme) => ({
  boxContainer: {
    [theme.breakpoints.up('sm')]: {
      height: theme.spacing(10),
    },
    width: '100%',
  },
  subtitle: {
    textTransform: 'uppercase',
    textAlign: 'center',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  imageWrapper: {
    top: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      top: theme.spacing(0),
      textAlign: 'center',
      margin: theme.spacing(1),
    },
  },
  image: {
    height: 300,
    objectFit: 'contain',
    [theme.breakpoints.between('sm', 'lg')]: {
      marginTop: theme.spacing(0),
    },

    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
    },
  },
}));

const ServiceItemsImages = ({ items = [], title, galleryIndex }: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const [partitions, setPartitions] = React.useState(chunk(items, 3));

  React.useEffect(() => {
    if (matches) {
      setPartitions(chunk(items, 1));
    }
  }, [matches]);

  return (
    <>
      {partitions[galleryIndex].map((item) => (
        <Grid key={item.id} item lg={4} xs={12} md={4}>
          <Box
            display="flex"
            alignContent="center"
            alignItems="center"
            component="div"
            className={classes.boxContainer}
          >
            <Typography
              className={classes.subtitle}
              component="div"
              color="primary"
              variant="h3"
              paragraph
            >
              {item.nombre}
            </Typography>
          </Box>
          <Box component="div">
            <GatsbyImage
              layout="constrained"
              loading="lazy"
              alt={title}
              image={item.galeria[0].gatsbyImageData}
              className={classes.imageWrapper}
              imgClassName={classes.image}
            />
          </Box>
        </Grid>
      ))}
    </>
  );
};

export default ServiceItemsImages;
